// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"46ed14ce","610":"63cf64df","749":"2d97acaa","791":"52481afb"}[chunkId] + ".chunk.js";
};